<template>
  <div>
    <section id="display-wraper" class="container">
      <display></display>
    </section>
    <section id="controller" class="">
      <div>
        <template>
          <div class="small-display" v-if="isSmallDisplay">
            <keep-alive>
              <component :is="current" />
            </keep-alive>
            <ul id="controller-menu">
              <li @click="onclick('notes')" :class="{active: current==='notes'}">入力</li>
              <li @click="onclick('player')" :class="{active: current==='player'}">再生</li>
              <li @click="onclick('setting')" :class="{active: current==='setting'}">その他</li>
            </ul>
          </div>
          <div class="wide-display" v-else>
            <div class="d-inline-block"><notes></notes></div>
            <div class="d-inline-block"><player></player></div>
            <div class="d-inline-block"><setting></setting></div>
          </div>
        </template>
        <div id="ad">
          <ad />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import display from '../components/app/display.vue'
import notes from '../components/app/input.vue'
import player from '../components/app/player.vue'
import setting from '../components/app/setting.vue'
import ad from '../components/app/ad.vue'
import {transfferURLparam} from '../url_trans/url_transffer'

export default {
  name: 'App',
  components: {
    display,
    notes,
    player,
    setting,
    ad
  },
  metaInfo: {
    title: 'Rhythm Reader アプリ｜リズムをその場で再生できる無料ツール',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: '音符を入力してすぐ再生。リズム確認・練習ができるWebアプリ本体。'
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://rhythm-calculator.colour-field.jp/ja/app'
      },
      {
        rel: 'alternate',
        hreflang: 'ja',
        href: 'https://rhythm-calculator.colour-field.jp/ja/app'
      },
      {
        rel: 'alternate',
        hreflang: 'en',
        href: 'https://rhythm-calculator.colour-field.jp/app'
      },
      {
        rel: 'alternate',
        hreflang: 'x-default',
        href: 'https://rhythm-calculator.colour-field.jp/app'
      }
    ]
  },
  data: function(){
    return {
      current: 'notes',
      isSmallDisplay: true,
    }
  },
  methods: {
    onclick: function(component){
      this.current = component;
    }
  },
  created: function(){
    const url = window.location.search.substring(1); 
    const url_params = new URLSearchParams(url);
    const rm = url_params.get("rm");
    const tp = url_params.get("tp");
    if (rm === null){
      // this.$store.commit('addnote', {note: {length: 960,  onoff: true,  dotted: false, tie: false}});
    } else {
      const imported_score = transfferURLparam(rm);
      for (let i = 0; i < imported_score.length; i++) {
        this.$store.commit('addnote', {'note':{//謎現象, 直に連想配列を代入できない
          length: imported_score[i].length,
          onoff: imported_score[i].onoff,
          dotted: imported_score[i].dotted,
          tie: imported_score[i].tie,
          }
        });
      }
    }
    // URLからテンポ取得
    if (tp !== null && 30 <= Number(tp) && Number(tp) <= 240){
      this.$store.commit('tempoChange', {tempo: Number(tp)});
    }

    // 画面サイズ取得
    let width = window.innerWidth;
    this.isSmallDisplay = width < 992;
    window.addEventListener("resize", () => {
      let width = window.innerWidth;
      this.isSmallDisplay = width < 992;
    });
  }
}
</script>

<style scoped>
header{
  text-align: left;
  padding: 4px;
  margin: 0 0 3px;
  background-color: var(--theme-color);
  color: #eee;
  border-bottom: 1px dotted #666;
  font-family: 'Raleway', sans-serif;
}
#display-wraper{
  margin: 3px auto 360px;
}
#controller{
  position: fixed;
  display: block;
  bottom: 0;
  width: 100%;
}
#controller > div{
  position: relative;
  display: block;
  margin: 0 auto;
  border-top: 1px solid #aaa;
}
#controller > div > div:first-child{
  background-color: #edf7ff;
}
ul#controller-menu{
  display: flex;
  list-style: none;
  justify-content: center;
  margin: 0;
  padding: 0;
  background-color: #edf7ff;
}
ul#controller-menu li{
  display: inline-block;
  position: relative;
  width: 120px;
  padding: 0.25rem 0;
  color: #999;
  background-color: #dddddd;
}
ul#controller-menu li.active{
  color: #000;
  background-color: #edf7ff;
  border-radius: 0 0 10px 10px;
}


.wide-display{
  display: flex;
  justify-content: center;

}
.wide-display > div{
  display: inline-block;
}

#ad{
  display: block;
  position: relative;
  width: 100%;
  height: 50px;
  background-color: #fff;
}
</style>
